module.exports = __webpack_public_path__ + "img/image.009db4c2.png";